const HAUL_SELL_RESUME_KEY = 'haulSellResume';

export type HaulSellResume = {
  claimId: string;
  lineId: string;
};

export function saveHaulSellResume(resume: HaulSellResume) {
  try {
    sessionStorage.setItem(HAUL_SELL_RESUME_KEY, JSON.stringify(resume));
  } catch {
    // ignore storage errors
  }
}

export function readHaulSellResume(): HaulSellResume | null {
  try {
    const raw = sessionStorage.getItem(HAUL_SELL_RESUME_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as HaulSellResume;
    if (parsed?.claimId && parsed?.lineId) return parsed;
  } catch {
    // ignore
  }
  return null;
}

export function clearHaulSellResume() {
  try {
    sessionStorage.removeItem(HAUL_SELL_RESUME_KEY);
  } catch {
    // ignore
  }
}
